import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/default.module.scss';

const propTypes = {
    color: PropTypes.string,
    fullscreen: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    fullscreen: false,
    className: null,
};

const FullscreenIcon = ({ color, fullscreen, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width={fullscreen ? '17.33px' : '15px'}
        height={fullscreen ? '17.33px' : '15px'}
        viewBox={fullscreen ? '0 0 17.33 17.33' : '0 0 15 15'}
        enableBackground={fullscreen ? 'new 0 0 0 17.33' : 'new 0 0 15 15'}
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <polygon
            fill={color}
            points={
                fullscreen
                    ? '1.48,6.67 6.67,6.67 6.67,1.48 5.03,3.11 1.92,0 0,1.92 3.11,5.03'
                    : '5.19,0 0,0 0,5.19 1.63,3.55 4.75,6.67 6.67,4.75 3.55,1.63'
            }
        />
        <polygon
            fill={color}
            points={
                fullscreen
                    ? '15.85,6.67 14.22,5.03 17.33,1.92 15.41,0 12.3,3.11 10.67,1.48 10.67,6.67'
                    : '9.81,0 11.45,1.63 8.33,4.75 10.25,6.67 13.37,3.55 15,5.19 15,0'
            }
        />
        <polygon
            fill={color}
            points={
                fullscreen
                    ? '15.41,17.33 17.33,15.41 14.22,12.3 15.85,10.67 10.67,10.67 10.67,15.85 12.3,14.22'
                    : '10.25,8.33 8.33,10.25 11.45,13.37 9.81,15 15,15 15,9.81 13.37,11.45'
            }
        />
        <polygon
            fill={color}
            points={
                fullscreen
                    ? '1.92,17.33 5.03,14.22 6.67,15.85 6.67,10.67 1.48,10.67 3.11,12.3 0,15.41'
                    : '4.75,8.33 1.63,11.45 0,9.81 0,15 5.19,15 3.55,13.37 6.67,10.25'
            }
        />
    </svg>
);

FullscreenIcon.propTypes = propTypes;
FullscreenIcon.defaultProps = defaultProps;

export default FullscreenIcon;
